// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { get } from 'lodash';

import ServiceLogo from 'web-ssr/app/services/components/ServiceLogo';
import Text from 'web-ssr/app/common/components/Text';
import 'web-ssr/app/services/components/ServicesSearch/ServiceDropdownItem.scss';

import type { appInfoFragment } from 'web-ssr/graphql/types';

const bem = bemify('service-dropdown-item');

type Props = {
  app: appInfoFragment,
  isSelected: boolean,
};

const ServiceDropdownItem = (props: Props) => {
  const { app, isSelected } = props;

  const images = get(app, ['images'], {});
  const serviceName = get(app, ['name']);

  return (
    <div className={bem(toModifiers({ selected: isSelected }))}>
      <ServiceLogo
        className={bem('__logo')}
        images={images}
        serviceName={serviceName}
      />
      <Text>{serviceName}</Text>
    </div>
  );
};

export default ServiceDropdownItem;
